<!--
 * @Author: zhaoliang
 * @Date: 2024-05-07 14:42:58
 * @LastEditTime: 2026-03-30 16:06:22
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/LoungePrebook/index.vue
 *
-->
<template>
  <div class="page-lounge-prebook-wrapper">
    <h1 class="title">{{ $t(title) }}</h1>
    <div class="content">
      <div class="step-wrapper">
        <div class="step1" v-show="currentStep === 1">
          <div class="step1-vistors">
            <div class="step1-vistors-desc">
              <h2>{{ $t('prebook-step1-desc1') }}</h2>
              <p>{{ $t('prebook-step1-desc2', [loungeInfo.maxPassengersCount]) }}</p>
            </div>
            <div class="step1-vistors-select">
              <Select :options="vistorOptions" :value="vistorNum" @onChange="onSelectChange" />
            </div>
          </div>
          <div class="step1-desc">
            <!-- {{ $t('prebook-step1-desc3') }} -->
            {{ loungeInfo.childrenNote }}
          </div>
          <div class="step1-date">
            <label class="form-label">{{ $t('prebook-step1-date') }}</label>
            <SelectDate
              :disabledDate="disabledDate"
              :value="dateValue"
              :errorStatus="!dateValue && checkErr"
              @onChange="onDateChange"
            />
            <p class="err-msg" v-if="!dateValue && checkErr">{{ $t('prebook-step1-errmsg1') }}</p>
          </div>
          <div class="step1-time">
            <label class="form-label">{{ $t('prebook-step1-time') }}</label>
            <SelectTime
              :options="timeOptions"
              :value="timeValue"
              :errorStatus="(!dateValue && checkErr) || showOtherTime || showNoTime"
              @onChange="onTimeChange"
              :onFocus="onTimeFocus"
            />
            <p class="err-msg" v-if="!timeValue && checkErr">{{ $t('prebook-step1-errmsg2') }}</p>
            <p class="err-msg" v-if="!dateValue && checkTimeErr">
              {{ $t('prebook-step1-errmsg1') }}
            </p>
            <!-- <p class="err-msg" v-if="showOtherTime">{{ $t('prebook-step1-errmsg3') }}</p>
            <p class="err-msg" v-if="showNoTime">{{ $t('prebook-step1-errmsg4') }}</p> -->
          </div>
          <div class="step1-choose-other-time" v-if="showOtherTime">
            <div class="step1-choose-other-time-title">{{ $t('prebook-step1-choose-time') }}</div>
            <div class="step1-choose-other-time-desc">{{ $t('prebook-step1-errmsg3') }}</div>
            <div v-for="(item, index) in otherTimeOptions" :key="index">
              <div
                class="step1-choose-other-time-options"
                :class="{ active: item.bookableTime === otherTimeValue }"
                @click="onOtherTimeChange(item.bookableTime)"
              >
                {{ item.bookableTime }} {{ item.shorter ? $t('prebook-step1-desc7') : '' }}
                <p
                  class="step1-choose-other-time-options-desc"
                  v-if="item.shorter && item.bookableTime === otherTimeValue"
                >
                  {{ $t('prebook-step1-desc9') }}
                </p>
              </div>
              <div
                class="step1-other-time-err"
                v-if="otherTimeValue === item.bookableTime && otherTimeError"
              >
                {{ $t('prebook-step1-errmsg5') }}
              </div>
            </div>
          </div>
          <div class="step1-choose-no-time" v-if="showNoTime">
            <div class="step1-choose-no-time-desc">{{ $t('prebook-step1-errmsg4') }}</div>
            <button class="step1-choose-no-time-btn" @click="goBackDetail">
              {{ $t('prebook-step1-exit-booking') }}
            </button>
          </div>
          <div class="step1-desc">
            <ul>
              <li>{{ $t('prebook-step1-desc4') }}</li>
              <li v-if="loungeInfo.cancelAble === 'true'">
                {{ $t('prebook-step1-desc5-allow-cancel') }}
              </li>
              <li v-else>{{ $t('prebook-step1-desc5-notallow-cancel') }}</li>
            </ul>
          </div>
          <div class="step1-button">
            <div class="previous-btn" @click="goBackDetail">
              <img src="~img/up.png" alt="icon-back" />
              <span>{{ $t('btn-previous') }}</span>
            </div>
            <button role="button" @click="continueToNext(true)" class="continue-btn">
              {{ $t('continue') }}
            </button>
          </div>
        </div>
        <div class="step2" v-show="currentStep === 2">
          <!-- <div class="step2-entitlements" v-if="calcNumOfHolder + calcNumOfPartner > 0"> -->
          <div class="step2-entitlements" v-if="entitlementsObj && entitlementsObj.num > 0">
            <div class="step2-entitlements-title">
              <img src="~img/icon-entitlement-solid.svg" alt="icon-entitlement" />
              <p>{{ $t('prebook-step2-entitlements') }}</p>
            </div>
            <!-- <div class="step2-entitlements-desc">
              {{ calcNumOfHolder + calcNumOfPartner }} x
              {{ $t('prebook-step2-entitlements-applied') }}
            </div> -->
            <div class="step2-entitlements-desc">
              {{ entitlementsObj.label }}
            </div>
          </div>
          <div class="step2-topay">
            <div class="step2-topay-title">
              <img src="~img/icon-card-outline.svg" alt="icon-card" />
              <p>{{ $t('prebook-step2-topay') }}</p>
            </div>
            <div class="step2-topay-desc" v-for="(item, index) in paymentList">
              <p class="step2-topay-payinfo">{{ item.label }}</p>
              <p class="step2-topay-total">{{ payInfo.currencyType }}{{ item.amount }}</p>
              <div class="step2-topay-dotted"></div>
            </div>
          </div>
          <div class="step2-divide"></div>
          <div class="step2-total-topay">
            <p>{{ $t('prebook-step2-total-topay', [payInfo.currencyLabel]) }}</p>
            <p>{{ payInfo.currencyType }}{{ payInfo.actualAmount }}</p>
          </div>
          <div class="step2-use-visit" v-if="dpCardInfo && dpCardInfo.length > 0">
            <div class="step2-use-visit-title">
              <img src="~img/icon-chair.svg" alt="" />
              <p>{{ $t('prebook-step2-use-visit-title') }}</p>
            </div>
            <div class="step2-use-visit-content" v-for="(item, index) in dpCardInfo" :key="index">
              <div class="step2-use-visit-desc">
                <p>{{ item.title }}</p>
                <p>{{ item.label }}</p>
              </div>
              <div class="step2-use-visit-num">
                <img
                  v-if="item.useVisitNum === item.min"
                  src="~img/icon-minus-circle-disabled.svg"
                  alt=""
                />
                <img
                  v-else
                  src="~img/icon-minus-circle.svg"
                  alt=""
                  @click="reduceNum(item, index)"
                />
                <span>{{ item.useVisitNum }}</span>
                <img
                  v-if="item.useVisitNum === item.limit"
                  src="~img/icon-plus-circle-disabled.svg"
                  alt=""
                />
                <img v-else src="~img/icon-plus-circle.svg" alt="" @click="addNum(item, index)" />
              </div>
            </div>
          </div>
          <div class="step2-terms">
            <p class="step2-terms-title">{{ $t('prebook-step2-terms-title') }}</p>
            <div class="check-terms">
              <div
                class="check-box"
                :class="{ checked: checked1, error: showTermsErr && !checked1 }"
                @click="
                  () => {
                    checked1 = !checked1;
                  }
                "
              >
                <img v-show="checked1" src="~img/icon-check.png" alt="checked icon" />
              </div>
              <span v-if="loungeInfo.cancelAble === 'true'">{{
                $t('prebook-step2-terms-desc1-allow-cancel')
              }}</span>
              <span v-else>{{ $t('prebook-step2-terms-desc1-notallow-cancel') }}</span>
            </div>
            <div class="check-terms">
              <div
                class="check-box"
                :class="{ checked: checked2, error: showTermsErr && !checked2 }"
                @click="
                  () => {
                    checked2 = !checked2;
                  }
                "
              >
                <img v-show="checked2" src="~img/icon-check.png" alt="checked icon" />
              </div>
              <span
                >{{ $t('prebook-step2-terms-desc2') }}
                <a style="font-weight: bold; cursor: pointer" @click="gotoTC">{{
                  $t('prebook-step2-terms-desc3')
                }}</a></span
              >
            </div>
            <p class="err-msg" v-if="showTermsErr && (!checked1 || !checked2)">
              {{ $t('prebook-step2-terms-errmsg') }}
            </p>
          </div>
          <div class="step2-card-info">
            <div class="step2-card-info-desc">
              <img src="~img/icon-pay-securely.svg" alt="" />
              <p>{{ $t('prebook-step2-card-info-desc') }}</p>
            </div>
            <div class="step2-card-info-cardnum">
              <img src="~img/icon-visa.svg" alt="" />
              <p>**** **** **** {{ creditCardInfo.last4 }}</p>
            </div>
          </div>
          <div class="step2-button">
            <button role="button" @click="payConfirm" class="pay-btn">
              {{ $t('prebook-step2-btn') }}
            </button>
          </div>
        </div>
      </div>
      <div class="lounge-info">
        <img :src="loungeInfo.imgUrl" alt="" />
        <div class="info-desc">
          <h2>{{ loungeInfo.name }}</h2>
          <p class="info-airport">
            {{ loungeInfo.airportName }}{{ loungeInfo.iataCode && ` ${loungeInfo.iataCode}`
            }}{{ loungeInfo.terminal && `, ${loungeInfo.terminal}`
            }}{{ loungeInfo.type && `, ${loungeInfo.type}`
            }}{{ loungeInfo.inspection && `, ${loungeInfo.inspection}`
            }}{{ loungeInfo.region && `, ${loungeInfo.region}` }}
          </p>
          <div class="prebooking-info" v-if="currentStep === 2">
            <div class="info-item">
              <img src="~img/icon-people.svg" alt="" />
              <p class="info-content">{{ vistorNum }} {{ $t('prebook-step2-passengers') }}</p>
            </div>
            <div class="info-item">
              <img src="~img/icon-calendar.svg" alt="" />
              <p class="info-content">{{ formatDate(dateValue) }}</p>
            </div>
            <div class="info-item">
              <img src="~img/icon-time-solid.svg" alt="" />
              <p class="info-content">
                {{ timeValue }} {{ $t('prebook-step2-service-hours', [loungeInfo.serviceHr]) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal
      :title="$t('prebook-book-fail-title')"
      :open="failModalVisbale"
      :okText="$t('prebook-book-fail-ok-btn')"
      :cancelText="$t('prebook-book-fail-cancel-btn')"
      @onOk="tryAgain"
      @onCancel="goToHome"
    >
      <template #content>
        <div>{{ errorMsg }}</div>
      </template>
    </Modal>
    <Modal
      :title="$t('prebook-book-check-title')"
      :open="checkModalVisbale"
      :okText="$t('continue')"
      :cancelText="$t('prebook-book-check-cancel-btn')"
      @onOk="checkPayInfo"
      @onCancel="forgetPsw"
    >
      <template #content>
        <input
          type="text"
          id="username"
          autocomplete="off"
          style="display: block; height: 0; opacity: 0; margin: 0; padding: 0"
        />
        <div>{{ $t('prebook-book-check-dec') }}</div>
        <div class="password-input">
          <input
            :class="{ error: checkPayInfoErr }"
            v-model="pswValue"
            :type="inputType"
            autocomplete="new-password"
            @input="checkPayInfoErr = false"
            :placeholder="$t('formPassword')"
          />
          <img
            v-show="showPsw"
            class="eye"
            src="~img/icon-feather-eye-on.svg"
            @click="
              showPsw = !showPsw;
              inputType = 'password';
            "
            alt="hide name"
          />
          <img
            v-show="!showPsw"
            class="eye"
            src="~img/icon-feather-eye-off.svg"
            @click="
              showPsw = !showPsw;
              inputType = 'text';
            "
            alt="show name"
          />
        </div>
        <p class="err-msg" v-if="checkPayInfoErr">{{ checkPayInfoMsg }}</p>
      </template>
    </Modal>
  </div>
</template>
<script>
  import Select from './Select';
  import SelectTime from './SelectTime';
  import SelectDate from './SelectDate';
  import Modal from './Modal';
  import { mapMutations, mapState } from 'vuex';
  const setpConfig = {
    step1title: 'prebook-step1-title',
    step2title: 'prebook-step2-title',
  };
  export default {
    name: 'LoungePrebook',
    components: {
      Select,
      SelectTime,
      SelectDate,
      Modal,
    },
    data() {
      return {
        currentStep: 1,
        title: setpConfig.step1title,
        goNextByBtn: true, // 是否通过点击按钮进入第二步,(有可能通过浏览器的前进按钮重新进入第二步,这时需要校验,但是不需要pushState)
        loungeInfo: {},
        // step1 data
        availableDate: [],
        vistorOptions: [1, 2, 3, 4, 5, 6],
        vistorNum: 1,
        timeOptions: [],
        timeValue: '',
        dateValue: '',
        checkErr: false,
        checkTimeErr: false,
        showOtherTime: false,
        otherTimeOptions: [],
        otherTimeValue: '',
        otherTimeError: false,
        showNoTime: false,
        bookingToken: '',
        // step2 data
        payInfo: {},
        useVisitNum: 0,
        dpCardInfo: [],
        creditCardInfo: {},
        checked1: false,
        checked2: false,
        showTermsErr: false,
        failModalVisbale: false,
        errorMsg: this.$t('prebook-book-fail-errmsg1'),
        checkModalVisbale: false,
        pswValue: '',
        checkPayInfoErr: false,
        checkPayInfoMsg: this.$t('prebook-book-fail-errmsg4'),
        inputType: 'password',
        showPsw: false,
      };
    },
    computed: {
      ...mapState(['userInfo']),
      calcNumOfHolder() {
        return this.dpCardInfo.find(item => item.type === '1')?.useVisitNum || 0;
      },
      calcNumOfPartner() {
        return this.dpCardInfo.find(item => item.type === '2')?.useVisitNum || 0;
      },
      paymentList() {
        // 不展示type1,2,7  type7等于1,2之和
        return (
          this.payInfo?.payments?.filter(
            item => item.type !== '1' && item.type !== '2' && item.type !== '7',
          ) || []
        );
      },
      entitlementsObj() {
        return this.payInfo?.payments?.find(item => item.type === '7') || {};
      },
    },
    watch: {
      currentStep(val) {
        if (val === 2) {
          this.getDragonpassCardInfo();
          this.getPayDetail({
            numOfPassengers: this.vistorNum,
            numOfHolder: 0,
            numOfPartner: 0,
          });
          this.getCreditCardInfo();
        }
      },
    },
    mounted() {
      this.getLoungeDetailsV2();
      this.getPrebookingDate();

      // this.getDragonpassCardInfo();
      // this.getPayDetail({
      //   numOfPassengers: this.vistorNum,
      //   numOfHolder: 0,
      //   numOfPartner: 0,
      // });
      // this.getCreditCardInfo();
    },
    created() {
      history.replaceState(
        {
          step: 1,
        },
        null,
        document.URL,
      );
      window.addEventListener('popstate', this.popstateEvent);
    },
    beforeUnmount() {
      window.removeEventListener('popstate', this.popstateEvent);
    },
    methods: {
      ...mapMutations(['showMessageModal']),
      popstateEvent() {
        this.checkModalVisbale = false;
        this.failModalVisbale = false;
        if (history.state.step === 1) {
          this.goToStep1();
        }
        if (history.state.step === 2) {
          // this.goToStep2();
          this.continueToNext(false);
        }
      },
      getLoungeDetailsV2() {
        const data = {
          lang: this.$i18n.locale,
          code: this.$route.query.loungeCode,
          userId: this.userInfo.userId,
          sessionId: this.userInfo.sessionId,
        };
        this.$http.lounge
          .getLoungeDetailsV2(data)
          .then(res => {
            if (res.state === '11') {
              this.loungeInfo = res.payload;
              this.vistorOptions = Array.from(
                { length: res.payload.maxPassengersCount },
                (_, index) => index + 1,
              );
            } else {
              this.showMessageModal({
                key: res?.note,
                i18nNeed: false,
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getPrebookingDate() {
        this.$http.lounge
          .getPrebookingDate({
            loungeCode: this.$route.query.loungeCode,
            lang: this.$i18n.locale,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
          })
          .then(res => {
            if (res.state === '11') {
              this.availableDate = res.payload.dateList;
            } else {
              this.showMessageModal({
                key: res?.note,
                i18nNeed: false,
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getPrebookingTime(date) {
        this.$http.lounge
          .getPrebookingTime({
            loungeCode: this.$route.query.loungeCode,
            lang: this.$i18n.locale,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
            date,
          })
          .then(res => {
            if (res.state === '11') {
              this.timeOptions = res.payload.times;
            } else {
              this.showMessageModal({
                key: res?.note,
                i18nNeed: false,
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      onSelectChange(value) {
        this.vistorNum = value;
        this.dateValue = '';
        this.timeValue = '';
        this.otherTimeValue = '';
        this.showOtherTime = false;
        this.showNoTime = false;
        this.checkErr = false;
        this.checkTimeErr = false;
        this.timeOptions = [];
      },
      onDateChange(value) {
        this.dateValue = value;
        this.timeValue = '';
        this.otherTimeValue = '';
        this.showOtherTime = false;
        this.showNoTime = false;
        this.checkErr = false;
        this.checkTimeErr = false;
        this.getPrebookingTime(value);
      },
      onTimeChange(value) {
        this.timeValue = value;
        this.otherTimeValue = '';
        this.showOtherTime = false;
        this.showNoTime = false;
      },
      onTimeFocus() {
        if (!this.dateValue) {
          this.checkTimeErr = true;
          return false;
        }
        return true;
      },
      onOtherTimeChange(value) {
        this.otherTimeError = false;
        this.otherTimeValue = value;
      },
      disabledDate(date) {
        return !this.availableDate.some(v => +new Date(`${v} 00:00:00`) === +date);
      },
      goBackDetail() {
        this.$router.back();
      },
      goToStep1() {
        this.currentStep = 1;
        this.title = setpConfig.step1title;
      },
      goToStep2() {
        if (this.goNextByBtn) {
          history.pushState(
            {
              step: 2,
            },
            null,
            document.URL,
          );
        }
        this.currentStep = 2;
        this.title = setpConfig.step2title;
      },
      continueToNext(goNextByBtn) {
        this.goNextByBtn = goNextByBtn;
        this.checkErr = true;
        if (this.otherTimeValue) {
          // 第二次选择时间
          this.checkOtherTimeAvailable();
        } else if (this.vistorNum && this.timeValue && this.dateValue) {
          this.checkSelectTimeAvailable();
        } else {
          // 通过浏览器前进按钮进入第二步但是校验未通过
          !goNextByBtn && history.back();
        }
      },
      checkSelectTimeAvailable() {
        this.$http.lounge
          .validationTime({
            loungeCode: this.$route.query.loungeCode,
            lang: this.$i18n.locale,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
            numOfPassengers: this.vistorNum,
            visitDateTimeText: `${this.dateValue} ${this.timeValue}`,
            recentAvailableCheck: true,
            forceUnavailableCheck: false,
          })
          .then(res => {
            if (res.state === '11') {
              if (res.payload.available) {
                this.reserveLounge(() => {
                  this.goToStep2();
                });
              } else if (
                res.payload.otherAvailableTimes &&
                res.payload.otherAvailableTimes.length > 0
              ) {
                this.otherTimeOptions = res.payload.otherAvailableTimes;
                this.showOtherTime = true;
              } else {
                this.showNoTime = true;
              }
            } else {
              this.showMessageModal({
                key: res?.note,
                i18nNeed: false,
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      checkOtherTimeAvailable() {
        this.$http.lounge
          .validationTime({
            loungeCode: this.$route.query.loungeCode,
            lang: this.$i18n.locale,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
            numOfPassengers: this.vistorNum,
            visitDateTimeText: `${this.dateValue} ${this.otherTimeValue}`,
            recentAvailableCheck: false,
            forceUnavailableCheck: false,
          })
          .then(res => {
            if (res.state === '11') {
              if (res.payload.available) {
                this.reserveLounge(() => {
                  this.goToStep2();
                  this.timeValue = this.otherTimeValue;
                  this.otherTimeValue = '';
                  this.showOtherTime = false;
                });
              } else {
                this.otherTimeError = true;
              }
            } else {
              this.showMessageModal({
                key: res?.note,
                i18nNeed: false,
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      forceGetOtherTime() {
        this.$http.lounge
          .validationTime({
            loungeCode: this.$route.query.loungeCode,
            lang: this.$i18n.locale,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
            numOfPassengers: this.vistorNum,
            visitDateTimeText: `${this.dateValue} ${this.timeValue}`,
            recentAvailableCheck: true,
            forceUnavailableCheck: true,
          })
          .then(res => {
            if (res.state === '11') {
              // forceUnavailableCheck为false, res.payload.available强制为false
              if (res.payload.available) {
                // do nothing
              } else if (
                res.payload.otherAvailableTimes &&
                res.payload.otherAvailableTimes.length > 0
              ) {
                this.otherTimeOptions = res.payload.otherAvailableTimes;
                this.showOtherTime = true;
              } else {
                this.showNoTime = true;
              }
            } else {
              this.showMessageModal({
                key: res?.note,
                i18nNeed: false,
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      reduceNum(item, index) {
        const visitNumTemp = item.useVisitNum === item.min ? item.min : item.useVisitNum - 1;
        if (item.useVisitNum === visitNumTemp) return;
        let currentNumOfHolder = this.calcNumOfHolder;
        let currentNumOfPartner = this.calcNumOfPartner;
        if (item.type === '1') {
          currentNumOfHolder = visitNumTemp;
        }
        if (item.type === '2') {
          currentNumOfPartner = visitNumTemp;
        }
        this.getPayDetail(
          {
            numOfPassengers: this.vistorNum,
            numOfHolder: currentNumOfHolder,
            numOfPartner: currentNumOfPartner,
          },
          () => {
            this.dpCardInfo[index].useVisitNum = visitNumTemp;
          },
        );
      },
      addNum(item, index) {
        const visitNumTemp = item.useVisitNum === item.limit ? item.limit : item.useVisitNum + 1;
        if (item.useVisitNum === visitNumTemp) return;
        let currentNumOfHolder = this.calcNumOfHolder;
        let currentNumOfPartner = this.calcNumOfPartner;
        if (item.type === '1') {
          currentNumOfHolder = visitNumTemp;
        }
        if (item.type === '2') {
          currentNumOfPartner = visitNumTemp;
        }
        this.getPayDetail(
          {
            numOfPassengers: this.vistorNum,
            numOfHolder: currentNumOfHolder,
            numOfPartner: currentNumOfPartner,
          },
          () => {
            this.dpCardInfo[index].useVisitNum = visitNumTemp;
          },
        );
      },
      payConfirm() {
        if (this.checked1 && this.checked2) {
          // 如果是支付是 0 元, 则不需要输入密码
          const raw = this.payInfo.actualAmount;
          const normalized = raw === null || raw === undefined ? '' : String(raw).trim();
          const amount = Number(normalized);
          if (normalized !== '' && Number.isFinite(amount) && amount > 0) {
            // 非 0 元
            this.checkModalVisbale = true;
          } else {
            this.checkPayInfo(true);
          }
        } else {
          this.showTermsErr = true;
        }
      },
      checkPayInfo(isZeroAmount = false) {
        // 检查密码是否为空 或者 0 元时不校验密码
        if (!this.pswValue.trim() && !isZeroAmount) {
          this.checkPayInfoErr = true;
          this.checkPayInfoMsg = this.$t('prebook-book-fail-errmsg4');
          return;
        }
        this.$http.lounge
          .payInfoConfirm({
            lang: this.$i18n.locale,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
            loungeCode: this.$route.query.loungeCode,
            numOfPassengers: this.vistorNum,
            visitDateTimeText: `${this.dateValue} ${this.timeValue}`,
            payDetail: this.payInfo,
            pw: this.pswValue,
            bookingToken: this.bookingToken,
          })
          .then(res => {
            if (res.state === '11') {
              this.checkModalVisbale = false;
              this.$router.push({
                path: '/prebooksuccess',
                query: {
                  orderNo: res.payload.orderNo,
                },
              });
            } else if (res.errorCode === 'error.lounge.prebook.confirm.token.expired') {
              this.checkModalVisbale = false;
              // 返回第一步并且调用时间校验接口
              this.goToStep1();
              this.forceGetOtherTime();
            } else if (
              res.errorCode === 'visa.invalid.pw' ||
              res.errorCode === 'visa.invalid.request'
            ) {
              this.checkPayInfoErr = true;
              this.checkPayInfoMsg = res.note;
            } else {
              this.checkModalVisbale = false;
              this.errorMsg = res.note;
              this.failModalVisbale = true;
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      goToHome() {
        this.failModalVisbale = false;
        this.checkModalVisbale = false;
        this.$nextTick(() => {
          // 跳转到首页
          this.$router.push({ path: '/' });
        });
      },
      tryAgain() {
        this.failModalVisbale = false;
      },
      forgetPsw() {
        this.$router.push({ path: '/login', query: { type: 'forget' } });
      },
      getDragonpassCardInfo() {
        this.$http.lounge
          .getDragonpassCardInfo({
            loungeCode: this.$route.query.loungeCode,
            lang: this.$i18n.locale,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
            numOfPassengers: this.vistorNum,
          })
          .then(res => {
            if (res.state === '11') {
              this.dpCardInfo = res.payload.map(item => {
                return {
                  ...item,
                  useVisitNum: 0,
                };
              });
            } else {
              this.showMessageModal({
                key: res.note,
                i18nNeed: false,
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getPayDetail(params, callback) {
        this.$http.lounge
          .getPayDetail({
            loungeCode: this.$route.query.loungeCode,
            lang: this.$i18n.locale,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
            ...params,
          })
          .then(res => {
            if (res.state === '11') {
              this.payInfo = res.payload;
              callback && callback();
            } else {
              this.showMessageModal({
                key: res.note,
                i18nNeed: false,
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getCreditCardInfo() {
        this.$http.lounge
          .getCreditCardInfo({
            lang: this.$i18n.locale,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
          })
          .then(res => {
            if (res.state === '11') {
              this.creditCardInfo = res.payload[0] || {};
            } else {
              this.showMessageModal({
                key: res.note,
                i18nNeed: false,
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      reserveLounge(callback) {
        this.$http.lounge
          .reserveLounge({
            lang: this.$i18n.locale,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
            loungeCode: this.$route.query.loungeCode,
            numOfPassengers: this.vistorNum,
            visitDateTimeText: `${this.dateValue} ${this.otherTimeValue || this.timeValue}`,
          })
          .then(res => {
            if (res.state === '11') {
              this.bookingToken = res.payload.bookingToken;
              if (callback && typeof callback === 'function') {
                callback();
              }
            } else {
              this.showMessageModal({
                key: res.note,
                i18nNeed: false,
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      formatDate(date) {
        const dateString = new Date(date).toDateString(); // 如 "Tue May 24 2024"
        const parts = dateString.split(' '); // 分割字符串为 ["Tue", "May", "24", "2024"]
        parts.shift(); // 移除数组的第一个元素（星期几）
        // 交换月份和日期
        const [month, day, year] = parts;
        return [day, month, year].join(' '); // 将剩余部分重新组合成字符串 "May 24 2024"
      },
      gotoTC() {
        window.open('/terms', '_blank');
      },
    },
  };
</script>
<style lang="scss" scoped>
  @import './index';
  @import './mobile';
</style>
